"use strict";
// Copyright (c) 2020, Brandon Lehmann
//
// Redistribution and use in source and binary forms, with or without modification, are
// permitted provided that the following conditions are met:
//
// 1. Redistributions of source code must retain the above copyright notice, this list of
//    conditions and the following disclaimer.
//
// 2. Redistributions in binary form must reproduce the above copyright notice, this list
//    of conditions and the following disclaimer in the documentation and/or other
//    materials provided with the distribution.
//
// 3. Neither the name of the copyright holder nor the names of its contributors may be
//    used to endorse or promote products derived from this software without specific
//    prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
// THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
// STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF
// THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = exports.LibraryType = void 0;
/**
 * The type of the underlying cryptographic library
 */
var LibraryType;
(function (LibraryType) {
    LibraryType[LibraryType["UNKNOWN"] = 0] = "UNKNOWN";
    LibraryType[LibraryType["NODE"] = 1] = "NODE";
    LibraryType[LibraryType["WASM"] = 2] = "WASM";
    LibraryType[LibraryType["JS"] = 3] = "JS";
})(LibraryType || (exports.LibraryType = LibraryType = {}));
/**
 * The type of the mnemonic phrase language
 *
 * Note: You will want to call the module `languages()` to get
 * the list of languages supported by the underlying cryptographic
 * module before attempting to use a particular language
 */
var Language;
(function (Language) {
    Language[Language["CHINESE_SIMPLIFIED"] = 0] = "CHINESE_SIMPLIFIED";
    Language[Language["CHINESE_TRADITIONAL"] = 1] = "CHINESE_TRADITIONAL";
    Language[Language["CZECH"] = 2] = "CZECH";
    Language[Language["ENGLISH"] = 3] = "ENGLISH";
    Language[Language["FRENCH"] = 4] = "FRENCH";
    Language[Language["ITALIAN"] = 5] = "ITALIAN";
    Language[Language["JAPANESE"] = 6] = "JAPANESE";
    Language[Language["KOREAN"] = 7] = "KOREAN";
    Language[Language["PORTUGUESE"] = 8] = "PORTUGUESE";
    Language[Language["SPANISH"] = 9] = "SPANISH";
})(Language || (exports.Language = Language = {}));
//# sourceMappingURL=types.js.map